var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrowYourBusinessIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "GrowYourBusiness_icon_svg__a",
    d: "M0 0h55.176v42.768H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "GrowYourBusiness_icon_svg__c",
    d: "M0 0h55.176v42.777H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "GrowYourBusiness_icon_svg__e",
    d: "M0 60h59.864V0H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.336 30.496c0 7.128-5.779 12.905-12.905 12.905-7.128 0-12.905-5.777-12.905-12.905 0-7.127 5.777-12.905 12.905-12.905 7.126 0 12.905 5.778 12.905 12.905",
    fill: "#E9EAEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.144 55.816c-.571 0-1.033-.463-1.033-1.032v-9.302h9.302a1.031 1.031 0 110 2.064H6.176v7.238c0 .57-.461 1.032-1.032 1.032",
    fill: "#EE4900"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "GrowYourBusiness_icon_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#GrowYourBusiness_icon_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.57 42.768c-.393 0-.767-.225-.94-.604C-2.48 30.958.002 17.517 8.803 8.715 14.442 3.078 21.923.015 29.978 0c8.009.017 15.528 3.134 21.17 8.778l3.726 3.725a1.031 1.031 0 11-1.46 1.46l-3.725-3.725C38.802-.65 21.116-.677 10.264 10.175 2.068 18.37-.246 30.882 4.508 41.305a1.033 1.033 0 01-.938 1.463",
    fill: "#EE4900",
    mask: "url(#GrowYourBusiness_icon_svg__b)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.687 17.223)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "GrowYourBusiness_icon_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#GrowYourBusiness_icon_svg__c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M25.257 42.777c-7.682 0-15.373-2.93-21.23-8.787L.302 30.265a1.033 1.033 0 011.46-1.46l3.725 3.726c10.887 10.885 28.571 10.913 39.425.062 8.196-8.197 10.51-20.707 5.756-31.131a1.034 1.034 0 011.88-.857c5.108 11.203 2.626 24.645-6.176 33.447-5.818 5.818-13.463 8.725-21.115 8.725",
    fill: "#EE4900",
    mask: "url(#GrowYourBusiness_icon_svg__d)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55.793 14.469H46.49a1.032 1.032 0 110-2.065h7.237V5.167a1.032 1.032 0 112.065 0v9.302z",
    fill: "#EE4900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.953 53.06c-4.66 0-9.152-1.383-12.99-3.999a1.032 1.032 0 111.164-1.706 20.91 20.91 0 0011.826 3.64c11.59 0 21.018-9.43 21.018-21.02 0-3.695-.972-7.33-2.811-10.51a1.03 1.03 0 01.376-1.411 1.03 1.03 0 011.41.377 23.08 23.08 0 013.09 11.544c0 12.728-10.355 23.084-23.083 23.084M10.853 42.035a1.03 1.03 0 01-.894-.515 23.068 23.068 0 01-3.091-11.545c0-12.729 10.356-23.085 23.085-23.085 4.66 0 9.15 1.383 12.987 3.999a1.033 1.033 0 01-1.163 1.705 20.906 20.906 0 00-11.824-3.639c-11.591 0-21.02 9.43-21.02 21.02 0 3.696.972 7.33 2.812 10.51a1.032 1.032 0 01-.892 1.55",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "GrowYourBusiness_icon_svg__f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#GrowYourBusiness_icon_svg__e"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F4A27F",
    mask: "url(#GrowYourBusiness_icon_svg__f)",
    d: "M34.076 41.336h8.26V24.818h-8.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4A27F",
    mask: "url(#GrowYourBusiness_icon_svg__f)",
    d: "M25.817 41.336h8.26v-25.81h-8.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4A27F",
    mask: "url(#GrowYourBusiness_icon_svg__f)",
    d: "M17.558 41.336h8.26V29.98h-8.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EE4900",
    mask: "url(#GrowYourBusiness_icon_svg__f)",
    d: "M43.369 41.337h-2.065V25.85h-6.195v15.486h-2.064V23.786h10.324z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EE4900",
    mask: "url(#GrowYourBusiness_icon_svg__f)",
    d: "M35.11 41.337h-2.065V16.559H26.85v24.778h-2.065V14.494H35.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EE4900",
    mask: "url(#GrowYourBusiness_icon_svg__f)",
    d: "M26.85 41.337h-2.065V31.013h-6.194v10.324h-2.065v-12.39H26.85z"
  }))));
}
export default SvgGrowYourBusinessIcon;